export default __webpack_public_path__ + "static/media/404.4ddbcdf9.png";